import * as React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  styled,
  Switch,
} from "@mui/material";
import { SupportedCommunicationPlatforms } from "fe-common/commonTypes/communicationLambdaApi";
import CloseIcon from "@mui/icons-material/Close";
import { ClinicActionButton } from "fe-web-components/clinic/clinicActionButton";
import { ReactComponent as EmailIcon } from "../../../../assets/clinic/emailIcon.svg";
import { ReactComponent as SMSIcon } from "../../../../assets/clinic/smsIcon.svg";

//region [[ Styles ]]

const CloseButton = styled(IconButton)({
  position: "absolute",
  top: 5,
  right: 5,
});
const MainContent = styled(DialogContent)({
  display: "flex",
  flexDirection: "column",
  gap: 4,
});
const MethodOption = styled("div")({
  display: "flex",
  flexDirection: "row",
});
const MethodSwitchLabel = styled("label")({
  display: "flex",
  gap: 8,
  alignItems: "center",
  fontSize: 16,
  width: 140,
  "& svg": {
    width: 24,
    height: 24,
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface SendingDialogProps {
  batchSize: number;
  sendMethods: SupportedCommunicationPlatforms[];
  onSend: () => void;
  onClose: () => void;
  onSetMethods: (methods: SupportedCommunicationPlatforms[]) => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]
export const SendingDialog = (props: SendingDialogProps) => {
  const { sendMethods } = props;
  const handleToggleMethod = (method: SupportedCommunicationPlatforms) => {
    if (sendMethods.includes(method))
      props.onSetMethods(sendMethods.filter((m) => m !== method));
    else props.onSetMethods([...sendMethods, method]);
  };

  return (
    <Dialog
      open={true}
      onClose={props.onClose}
      aria-labelledby="sending-dialog-title"
      aria-describedby="sending-dialog-description"
    >
      <CloseButton onClick={props.onClose}>
        <CloseIcon />
      </CloseButton>
      <DialogTitle id="patient-dialog-title">Send invitations</DialogTitle>
      <MainContent>
        <div style={{ marginBottom: 4 }}>
          You are about to send an invitation to {props.batchSize} selected
          patients:
        </div>
        <MethodOption>
          <MethodSwitchLabel htmlFor="sendEmail">
            <EmailIcon />
            Send to Email
          </MethodSwitchLabel>
          <Switch
            id="sendEmail"
            checked={sendMethods.includes(
              SupportedCommunicationPlatforms.Email,
            )}
            onChange={() =>
              handleToggleMethod(SupportedCommunicationPlatforms.Email)
            }
            name="email"
          />
        </MethodOption>
        <MethodOption>
          <MethodSwitchLabel htmlFor="sendSms">
            <SMSIcon />
            Send to SMS
          </MethodSwitchLabel>
          <Switch
            id="sendSms"
            checked={sendMethods.includes(SupportedCommunicationPlatforms.SMS)}
            onChange={() =>
              handleToggleMethod(SupportedCommunicationPlatforms.SMS)
            }
            name="sms"
          />
        </MethodOption>
      </MainContent>
      <DialogActions style={{ padding: 20 }}>
        <ClinicActionButton
          onClick={() => {
            props.onSend();
            props.onClose();
          }}
          disabled={sendMethods.length === 0}
          label="Send Now"
        />
      </DialogActions>
    </Dialog>
  );
};
